module.exports = __webpack_public_path__ + "img/assign-to-sites.fb7cbc27.svg";